// base
import React, { useMemo } from 'react';

// libraries
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, type ChartData, type ChartOptions } from 'chart.js';
import annotaionPlugin from 'chartjs-plugin-annotation';

ChartJS.register(ArcElement, Tooltip, annotaionPlugin);

interface DonutChartProps {
  chartData: ChartData<'doughnut'>;
  customOptions?: ChartOptions<'doughnut'>;
}

export const DonutChart: React.FC<DonutChartProps> = ({ chartData, customOptions }) => {
  const options: ChartOptions<'doughnut'> = useMemo(() => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '70%',
      rotation: 0,
      spacing: 2,
      plugins: {
        legend: {
          display: false
        },
        title: {
          display: false
        },
        tooltip: {
          enabled: false,
          animation: { duration: 0 }
        }
      },
      ...customOptions
    };
  }, [customOptions]);

  return <Doughnut data={chartData} options={options} redraw updateMode="resize" />;
};
